import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    accountHeaderContainer: { padding: '1rem 3rem 2rem 3rem' },
    accountNameDetails: {
        fontSize: '.9rem',
        paddingBottom: '.3rem'
    },
    accountNumberDetails: {
        fontSize: '.9rem',
        paddingBottom: '.3rem',
        marginLeft: '1rem',
        fontWeight: 'bold' as const
    },
    accountName: { fontSize: '1.5rem' },
    accountNotifyEmail: {
        fontSize: '.8rem',
        paddingTop: '.6rem'
    },
    statusSymbol: {
        marginLeft: '1rem',
        '&:first-child': { marginLeft: 0 }
    },
    pcgDivider: {
        marginTop: '.5rem',
        marginBottom: '1rem'
    },
    pcgNumber: {
        backgroundColor: theme?.app?.applicationColors.detailTagBackground || '#E4EFFA',
        borderRadius: '6px',
        padding: '.2rem .4rem',
        marginRight: '1rem',
        marginBottom: '.5rem',
        fontSize: '.9rem'
    },
    detailLabel: {
        color: theme?.app?.applicationColors.fontDetailColor || '#4A4C50',
        fontSize: '.7rem',
        paddingBottom: '.3rem'
    },
    accountDetail: {
        color: theme?.app?.applicationColors.fontColor || '#202020',
        fontSize: '1rem',
        paddingBottom: '.75rem',
        wordBreak: 'break-all' as const
    },
    accountTimeDetail: {
        color: theme?.app?.applicationColors.fontColor || '#202020',
        fontSize: '.8rem',
        paddingBottom: '.25rem',
        wordBreak: 'break-all' as const
    },
    verticalDivider: { height: 'auto' as const },
    noNotes: { color: theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf' },
    accountAdditionalInfoContainer: {
        flexGrow: 1,
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#F1F2F2',
        padding: '1.5rem 2.5rem'
    },
    accountAdditionalInfoPanel: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem'
    },
    actionButtonsContainer: { flexBasis: 'auto' as const },
    closedTag: { marginRight: '1rem' }
});